import { render, staticRenderFns } from "./tag-detail.vue?vue&type=template&id=4dcfd54d&scoped=true&"
import script from "./tag-detail.vue?vue&type=script&lang=js&"
export * from "./tag-detail.vue?vue&type=script&lang=js&"
import style0 from "./tag-detail.vue?vue&type=style&index=0&id=4dcfd54d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcfd54d",
  null
  
)

component.options.__file = "tag-detail.vue"
export default component.exports